export default __webpack_public_path__ + "static/media/loading_white.0583f62f.gif";